import { Stack } from '@mui/material';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import Header from '/@/components/bayer/header';
import PageContainer from '/@/components/bayer/page-container';
import Spinner from '/@/components/spinner';
import { useOwnUserNode } from '/@/hooks/nodes';
import { useCurrentCampaignYear } from '/@/hooks/zones';
import { _ } from '/@/locale';
import { getNodeScopeFilters } from '/@/utils/node-scope';
import FieldMonitoringDashboardPastReports from '/@/views/fields/field-monitoring/dashboard/tabs/past-reports';
import { PastReportsDashboardCards } from '../../growers/tabs/past-campaign';

const GrowerReportsView = () => {
    const growerNodeId = useOwnUserNode();
    const currentCampaignYear = useCurrentCampaignYear();
    const form = useForm<{
        year: number;
    }>({
        defaultValues: {
            year: currentCampaignYear ?? new Date().getFullYear(),
        },
    });

    // Update form value when currentCampaignYear becomes available
    useEffect(() => {
        if (currentCampaignYear !== null) {
            form.setValue('year', currentCampaignYear);
        }
    }, [currentCampaignYear, form]);

    if (!growerNodeId.data?.id) {
        return (
            <Stack height='100%' width='100%' alignItems='center' justifyContent='center'>
                <Spinner />
            </Stack>
        );
    }

    return (
        <PageContainer
            header={
                <Header
                    title={_('Reportes de campaña')}
                    subtitle={_(
                        'Accedé al resumen de resultados de los lotes para analizar el rendimiento y planificar la próxima campaña.'
                    )}
                />
            }
        >
            <Stack direction='column' spacing={3} py={4}>
                <PastReportsDashboardCards
                    year={form.watch('year')}
                    growerNodeId={growerNodeId.data?.id}
                    isRv={false}
                    nodeScope={getNodeScopeFilters('myFields')}
                />
                <FieldMonitoringDashboardPastReports
                    growerNodeId={growerNodeId.data?.id}
                    year={form.watch('year')}
                    nodeScope={getNodeScopeFilters('myFields')}
                />
            </Stack>
        </PageContainer>
    );
};

export default GrowerReportsView;
